export const icons: { [key: string]: string } = {
  'icon-certificateOk': require('!svg-inline-loader!$assets/images/icons_set/icon-certificateOk.svg'),
  'icon-checkmark': require('!svg-inline-loader!$assets/images/icons_set/icon-checkmark.svg'),
  'icon-close': require('!svg-inline-loader!$assets/images/icons_set/icon-close.svg'),
  'icon-mailOk': require('!svg-inline-loader!$assets/images/icons_set/icon-mailOk.svg'),
  'icon-pdf': require('!svg-inline-loader!$assets/images/icons_set/icon-pdf.svg'),
  'icon-rouble': require('!svg-inline-loader!$assets/images/icons_set/icon-rouble.svg'),
  'icon-subscribe': require('!svg-inline-loader!$assets/images/icons_set/icon-subscribe.svg'),
  'icon-waitOk': require('!svg-inline-loader!$assets/images/icons_set/icon-waitOk.svg'),
  'icon-warn-unsaved-data': require('!svg-inline-loader!$assets/images/icons_set/icon-warn-unsaved-data.svg'),
}

export const addClassToInline = (icon: string, className: string): string => {
  return icon.replace('<svg', `<svg class='${className}'`)
}

export const getIcon = (iconName: string, className?: string) => {
  return className
    ? addClassToInline(icons[iconName], className)
    : icons[iconName]
}
